import getApi from '../api/getApi';
import postApi from '../api/postApi';

/** GET /reviews — fetch all customer reviews */
export const fetchAllReviews = () => getApi('/reviews');

/** POST /reviews — submit a new review */
export const submitReview = (data) => postApi('/reviews', data);
